import { useIntl } from "react-intl";

import type { TravellerType } from "@/features/trips/types/types";

const labelMap: Record<TravellerType, string> = {
  adultInDoubleRoom: "adultInDoubleRoom.title",
  adultInSingleRoom: "adultInSingleRoom.title",
  childWithBed: "childWithBed.title",
  childWithoutBed: "childWithoutBed.title",
  infant: "infant.title",
};

type Props = {
  rooms: Record<TravellerType, number>;
};

export function RoomList({ rooms }: Props) {
  const intl = useIntl();

  return (
    <ul className="space-y-1 text-sm font-medium text-text-primary">
      {Object.entries(rooms).map(([travellerType, count]) => {
        if (count === 0) return null;

        return (
          <li key={travellerType} className="text-sm">
            {count}x{" "}
            {intl.formatMessage({
              id: `trips.travellersSelection.${labelMap[travellerType as TravellerType]}`,
            })}
          </li>
        );
      })}
    </ul>
  );
}
